<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5o9ADw/tc-custom/9781488000690.jpg?1705894967789" alt="This image is the cover for the book Bound to the Tuscan Billionaire, One Night With Consequences"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bound to the Tuscan Billionaire, One Night With Consequences
      </h1>
      <p class="bookDescription body article font2">
        <b>She’s as intoxicating as the flowers at his villa. Desire blooms into so much more in this stunning romance from the <i>USA Today</i>–bestselling author.</b><br/><br/>For gardener Cassandra Rich, working in the foothills of Tuscany is the perfect way to escape her past. Until the man of the manor graces the villa with his presence and Cassandra with his attention.<br/><br/>Marco di Fivizzano can’t take his eyes off the delectable Cass. So when he requires a plus one for a gala, Marco will uncover who this fiery blonde is—over dinner, or in his bed!<br/><br/>In Marco’s arms, Cass blossoms, finding the freedom she’s always craved . . . until she discovers she’s pregnant and bound to the billionaire forever!<br/><br/><b>“Excellent descriptions and a well-written storyline combine to make for an enjoyable read.” —<i>RT Book Reviews</i> (4 stars)</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Stephens
      </h2>
      
      <p class="authorDescription body article">Susan Stephens&#160;is passionate about writing&#160;books set in fabulous locations where an outstanding man comes to grips with a cool, feisty woman.&#160;Susan&rsquo;s hobbies include travel, reading, theatre, long walks, playing the piano, and she loves hearing from readers at her website. <a href="http://www.susanstephens.com">www.susanstephens.com</a></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7fe0d8e3